import { GET_ALL_SERIES_SUCCESS } from '../actions/actionTypes';

export default function allSeries(state = [], action) {
  switch (action.type) {
    case GET_ALL_SERIES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
